// extracted by mini-css-extract-plugin
module.exports = {"CandidateResume":"_15C5l_jT","CandidateResumeModal":"_1zmqztsy","viewCandidate":"_1o9haVEb","profileHeaderContainer":"_2iwck9UR","profileImagePlaceholder":"_3G0R5pH2","profileHeaderDetails":"_5XvVDZdr","profileNameContainer":"_2_2kBeNN","profileName":"_375jQEOu","profileNameSubtitle":"LRVS8xGQ","profileSubtitleDetails":"_1w_2yzhl","profileLinks":"_1cvy1ST2","scrollDiv":"_9tmpPCf_","emptyButton":"_3pjHkKCC"};
    if(module.hot) {
      // 1746735815557
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  